import React from 'react';

export default function AlimentarIndicadoresPage() {
  return (
    <div>
      Qualidade - Alimentar Indicadores (placeholder).
    </div>
  );
}

